module.exports = __webpack_public_path__ + "img/sunshine_1248.69d75bee.png";